import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";
import { AuthI18N } from "@whatslly/ui-components/Pages/Authi18n";
import { TuvisMessagingI18N } from "@whatslly/ui-components/Pages/TuvisMessaging/TuvisMessagingI18N";
import translationEN from "./en/translation.json";
import translationES from "./es/translation.json";
import translationPT from "./pt/translation.json";

i18n.addResources("en", defaultNS, flattenResources({ ...AuthI18N.en, ...TuvisMessagingI18N.en, ...translationEN }));
i18n.addResources("es", defaultNS, flattenResources({ ...AuthI18N.es, ...TuvisMessagingI18N.es, ...translationES }));
i18n.addResources("pt", defaultNS, flattenResources({ ...AuthI18N.pt, ...TuvisMessagingI18N.pt, ...translationPT }));

export default i18n;
